import {   PatientFlagsControllerApi, PatientMultipleFlagsRequest,   } from "../../../services";
import { getConfigObject, useMutationWithLoading } from "../../../utils/utils";

/**
 *
 * @author [Atish Bagate]
 */

interface Params {
  patientMultipleFlagsRequest: PatientMultipleFlagsRequest;
  xTENANTID?: string;
}

export const useAddPatientFlagByPatientId = () =>
  useMutationWithLoading(async (params: Params) =>
    new PatientFlagsControllerApi(getConfigObject()).assignMultipleFlagsToPatient(
      params.patientMultipleFlagsRequest,
      params.xTENANTID
    )
  );
